// Canonical page-view vocabulary. Both browser helpers and POST /api/views
// fail closed against this set, so a route cannot accidentally turn an
// arbitrary URL, search query, or user value into a new analytics dimension.

export const PAGE_VIEW_PAGES = Object.freeze({
  // Main app
  home: 'Home',
  stats: 'Profile stats',
  leaderboards: 'Leaderboards',
  settings: 'Settings',
  rooms: 'Rooms',
  friends: 'Friends',
  top100: 'Top 100',
  contact: 'Contact',
  replays: 'Replay browser',
  'replay-detail': 'Replay detail',
  'clip-detail': 'Clip detail',

  // Library app
  library: 'Library catalog',
  'game-detail': 'Game detail',
  'library-lists': 'Library lists',
  'library-public-lists': 'Public library lists',
  'library-list-detail': 'Library list detail',
  'library-filter-builder': 'Library filter builder',
  'library-settings': 'Library settings',

  // Store app
  store: 'Store catalog',
  'store-item-detail': 'Store item detail',
  'store-bundle-detail': 'Store bundle detail',
  'store-bundles': 'Store bundles',
  'store-inventory': 'Store inventory',
  'store-balance': 'Store balance',
  'store-subscribe': 'Store subscription',

  // Reserved shipped/future main-app surfaces already accepted by ingest.
  feed: 'Activity feed',
  social: 'Social',
});

export const PAGE_VIEW_PAGE_IDS = new Set(Object.keys(PAGE_VIEW_PAGES));

export function isKnownPageView(page) {
  return typeof page === 'string' && Object.hasOwn(PAGE_VIEW_PAGES, page);
}

// The table deliberately has no anonymous browser identifier. Anonymous rows
// are included in non-bot chart views, but COUNT(DISTINCT user_id) can only
// measure signed-in accounts because PostgreSQL excludes NULL. Both chart
// views and account uniqueness exclude identified bots; recorded totals retain
// them. Historical anonymous traffic remains explicitly unclassified.
export const PAGE_VIEW_UNIQUE_IDENTITY_SCOPE = 'signed_in_accounts_only';
